import { FC, ReactNode } from "react";

interface Props {
  items?: { element: JSX.Element; link?: string }[];
  children: ReactNode;
}

export const AccountPageLayout: FC<Props> = ({ children }) => {
  return (
    <article className="min-h-screen">
      <div className="pb-[104px] m-auto md:p-4 md:pt-12">{children}</div>
    </article>
  );
};
